/**
 * CWSカテゴリ変換マスタ設定画面Output用VOクラス
 */
export class KYMW6801OutputModel {
  /**
   * カテゴリ区分
   */
  public categoryDiv: string = <string>'';
  /**
   * カテゴリコード
   */
  public categoryCode: string = <string>'';
}
